// A full navigation keeps the selected offer, supporting LP content and cart ID together.
class AdvertisedLpOptions extends HTMLElement {
  connectedCallback() {
    const current = new URL(window.location.href);
    for (const link of this.querySelectorAll('a[href]')) {
      const destination = new URL(link.href);
      const owned = new Set(destination.searchParams.keys());
      for (const [key, value] of current.searchParams) {
        if (!owned.has(key)) destination.searchParams.append(key, value);
      }
      link.href = destination.href;
    }
  }
}
if (!customElements.get('advertised-lp-options')) {
  customElements.define('advertised-lp-options', AdvertisedLpOptions);
}

// Retain the LP controls while making their existing click behavior keyboard accessible.
function enhanceLpControls() {
  const controls = document.querySelectorAll(
    '[data-lp-family] [onclick], [data-lp-family] .sk-bundle-ingredients__header'
  );
  for (const control of controls) {
    if (control.matches('a, button, summary, input, select, textarea')) continue;
    control.setAttribute('role', 'button');
    control.tabIndex = 0;
    control.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      control.click();
    });
  }
  function syncDisclosureState() {
    for (const control of controls) {
      if (!control.hasAttribute('onclick')) continue;
      const panel = control.nextElementSibling;
      if (panel) control.setAttribute('aria-expanded', String(!panel.classList.contains('hidden')));
    }
  }
  syncDisclosureState();
  document.querySelector('[data-lp-family]')?.addEventListener('click', syncDisclosureState);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceLpControls, { once: true });
} else {
  enhanceLpControls();
}
